/**
 * 新增 or 编辑
 */
import {useRef, useState} from 'react'
import {SLowcodeList, STriggerModal} from 'shj-components'
import config from './config'
import {apiData2Table} from '@/utils/data.ts'
import {getCustomerSource, launchAccountPageWithoutPermission} from '@/services/customerServices'
import {message, TreeSelect} from 'antd'

const ModalSingleDom = (props: any) => {
  const {onClose, onFinish} = props
  const {open} = props.option
  const [sourceChannel, setSourceChannel] = useState([])
  const listRef = useRef<any>()
  const _onFinish = () => {
    const [rowKeys, rows] = listRef?.current?.getSelectedRows()
    if (rowKeys.length < 1) {
      message.warning('至少选择一条数据!')
      return
    }
    console.log(rowKeys, rows)
    onFinish(rowKeys, rows)
    _onClose()
  }
  const _onClose = () => {
    onClose && onClose()
    _resetSelect()
  }

  const _resetSelect = () => {
    listRef?.current?.clearSelectedRowKeys()
  }

  const fetchList = (values: any) => {
    return new Promise((resolve, reject) => {
      try {
        const {current, pageSize, query} = values
        const data = {
          ...query,
          queryOrgName: true,
          queryChannelName: true,
          queryChannelTypeName: true,
        }
        launchAccountPageWithoutPermission({
          current,
          pageSize,
          data,
        }).then((resp: any) => {
          resolve(apiData2Table(resp))
        })
      } catch {
        reject({success: false})
      }
    })
  }

  const getStatusOptions = () => {
    return new Promise(async resolve => {
      const channel = await getCustomerSource()
      setSourceChannel(channel)
      resolve({})
    })
  }

  const extension = {
    request: {fetchList, getStatusOptions},
    events: {},
    // auth: authMap,
    status: {
      btnDisabled: ({selectedRowKeys}: any) => selectedRowKeys.length <= 0,
    },
    customRender: {
      treeSelect({key}: { key: any }) {
        return (
          <TreeSelect key={key} placeholder="请选择" allowClear={true} treeData={sourceChannel}/>
        )
      },
    },
  }

  return (
    <STriggerModal
      title={'选择线索账号'}
      open={open}
      cancelText="取消"
      okText="确定"
      onOk={_onFinish}
      onCancel={_onClose}
      width={'86%'}
    >
      <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} />
    </STriggerModal>
  )
}

export default ModalSingleDom
